import actionTypes from './actionTypes';

export const fetch = (filters = {}) => ({
  type: actionTypes.FETCH,
  payload: {
    filters,
  },
});

export const fetchNext = () => ({
  type: actionTypes.FETCH_NEXT,
});

export const fetchPrev = () => ({
  type: actionTypes.FETCH_PREV,
});

export const fetching = () => ({
  type: actionTypes.FETCHING,
});

export const fetched = (data = [], meta = {}) => ({
  type: actionTypes.FETCHED,
  payload: {
    data,
  },
  meta,
});

export const updateShipment = (shipmentId, data = {}) => ({
  type: actionTypes.UPDATE_SHIPMENT,
  payload: {
    ...data,
    shipmentId,
  },
});

export const cancel = (payload) => ({
  type: actionTypes.CANCEL,
  payload: {
    ...payload,
  },
});

export const cancelled = (payload) => ({
  type: actionTypes.CANCELLED,
  payload: {
    ...payload,
  },
});

export const updateRecipient = (values) => ({
  type: actionTypes.UPDATE_RECIPIENT,
  payload: {
    values,
  },
});

export const updatedRecipient = () => ({
  type: actionTypes.UPDATED_RECIPIENT,
  payload: {},
});

export const toggleRecipientScreen = () => ({
  type: actionTypes.TOGGLE_UPDATE_RECIPIENT_SCREEN,
  payload: {},
});
